import {useEffect} from 'react';
import {haboClickReport} from '@/plugins/habo';
import {IEventName} from '@/constants/haboEventId';

const useViewReport = (name: IEventName, ...others: IReportInfo[]) => {
    useEffect(() => {
        haboClickReport(name, ...others);
    }, []);
};

export default useViewReport;
